module.exports = __webpack_public_path__ + "assets/img/00035.ffe97cd5.png";